<template>
  <div id="app">
    <img alt="Bunch logo" src="https://dl.dropbox.com/s/f5byhvf73nyan43/bunch_purple_logo.png" style="width:100px;" class="mb-2">
    <Reviews msg="Wine review generator"/>
  </div>
</template>

<script>
import Reviews from './components/Reviews.vue'

export default {
  name: 'app',
  components: {
    Reviews
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Raleway|Oswald');
#app {
  font-family: 'Raleway', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
